import React from 'react';
import {
    UserStatusBadge,
    badge,
} from '../../UserUIHelpers';

import Moment from 'react-moment';


export function RoleColumnFormatter(cellContent, row) {

    let data = badge(cellContent);
    return (
        <span className={`label label-lg label-light-${data.type} label-inline`}>
            {data.text}
        </span>
    );
}

export function StatusColumnFormatter(cellContent, row) {

    const getLabelCssClasses = () => {
        return `label label-lg label-light-${UserStatusBadge[cellContent].type
            } label-inline`;
    };

    return (
        <span className={getLabelCssClasses()}>
            {UserStatusBadge[cellContent].text}
        </span>
    );

}

export function ActiveUntilColumnFormatter(cellContent, row) {

    let now = new Date()
    let entryDate = new Date(cellContent)
    const styleDeterminer = () => {
        if (!cellContent) {
            return 'success'
        } else if (entryDate > now) {
            return 'warning'
        } else if (entryDate < now) {
            return 'danger'
        }
    }


    return (
        <span className={`label label-lg label-light-${styleDeterminer()} label-inline`}>
            {cellContent ? <Moment format="DD-MM-YYYY">{cellContent}</Moment> : "Aktif Selamanya"}
        </span>
    );

}